/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Schedule_TitleInputs */

const vi_irrigation_schedule_title = /** @type {(inputs: Irrigation_Schedule_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lịch tưới · ${i?.name}`)
};

/**

* @param {Irrigation_Schedule_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_title = /** @type {((inputs: Irrigation_Schedule_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_title(inputs)
});